// extracted by mini-css-extract-plugin
var _1 = "CalendarViewNewMenu-moduleCalendarViewNewMenu__WzV1q Select-moduleSelect__MROu3";
var _2 = "CalendarViewNewMenu-moduledropdown__WWQnw SelectDropdownList-moduleSelectDropdownList__xvHZa SelectDropdown-moduleSelectDropdown__s9tE2";
export { _1 as "CalendarViewNewMenu", _2 as "dropdown" }
